<template>
    <section>
      <b-container>
        <b-row align-v="center" class="row-grid">
          <b-col md="6" class="order-md-2">
            <b-img src="img/custom/mumm_sm.png" fluid />
          </b-col>
          <b-col md="6" class="order-md-1">
            <div class="pr-md-5">
              <h1>Do you have 120+ publication-ready images?</h1>
              <p v-if="(currentSnapWizard.format == 'a4')">Publication-ready means: image placed on a full A4 page needs to have a
minimum of 3500 pixels on the long side and a resolution of 300 dpi. For full
spread images, the image needs to have a minimum of 4700 pixels on the
long side.</p>

<p v-if="(currentSnapWizard.format == '30x30')">Publication ready means: Image placed on a full 30x30 page needs to
have a minimum of 3500 pixels on the long side and a resolution of 300
dpi. For Full spread images, the image needs to have a minimum of
7000 pixels on the long side.</p>

                    
                        <strong v-if="show_sorry">We're Sorry. Keep Creating and Come Back Soon!</strong>
                        <p v-if="show_sorry">Please continue refining your portfolio. Once you have 120+ publication-ready images, we'd love to work together! Feel free to reach out then.</p>
              <b-form-radio-group v-model="currentSnapWizard.images_ready">
                        <div>
                            <b-form-radio value="1" name="unchecked" class="mb-3">
                                Yes, I do
                            </b-form-radio>
                        </div>
                        <div>
                            <b-form-radio value="0" name="checked" class="mb-3">
                                No, not yet
                            </b-form-radio>
                        </div>
                    </b-form-radio-group>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

  

</template>
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import TagsInput from '@/components/Inputs/TagsInput'

export default {
    name: 'snap01',
    components: {
        TagsInput,
        [Tooltip.name]: Tooltip
    },
    methods: {
        onCancel: function () { },
        onProceed: function () { },
        allDataValidated: function () {
                /*
                console.log(this.currentPhotoBook.title);
                console.log(this.currentPhotoBook.subtitle);
                console.log(this.currentPhotoBook.blurb);
                console.log(this.currentPhotoBook.bio);
                console.log(this.currentPhotoBook.orientation);
                console.log(this.currentPhotoBook.keywords);
                */
            if (
                this.currentSnapWizard.images_ready == 1
            ) {
                //this.claim.allValidated = true;
                console.log("VALID ENABLING NEXT");
                this.$emit('allowProceed');
                this.$emit('showFooterNav');
                return true;
            }
            this.$emit('denyProceed');
            this.$emit('hideFooterNav');
            return false;
        },
    },
    computed: {
        ...mapGetters({
            currentSettings: 'currentSettings',
            currentSnapWizard: 'currentSnapWizard',
            currentSnapWizardStep: 'currentSnapWizardStep',
        }),
        show_images_hint() {
            if(this.currentSnapWizard.images_ready == 1 || this.currentSnapWizard.images_ready == undefined){
                return true;
            }
            else{
                return false;
            }
        },
        show_sorry() {
            if(this.currentSnapWizard.images_ready == 0 || this.currentSnapWizard.images_ready == "" ){
                return true;
            }
            else{
                return false;
            }
        },
    },
    watch: {
        currentSnapWizard: {
            handler:function (newItem) {
                //console.log("DEEPWATCH");//this.doSomethingWith(newItem);
                //this.currentPhotoBook.keywords = this.currentPhotoBook.keywords.split(',');
                this.allDataValidated();
            },
            deep: true
        },
    },
    mounted() {
        this.$emit('denyProceed');
        this.$emit('hideFooterNav');
        this.allDataValidated();
    }
};
</script>